<template>
    <SimpleModal
        v-if="showModal"
        :show-close-button="false"
        @close="$emit('close')"
    >
        <template v-slot:header>
            <h2>Report conversation</h2>
        </template>
        <template v-slot:body>
            <p>
                <strong>Why do you want to report this conversation?</strong>
            </p>
            <div class="form-group">
                <div
                    v-for="(reason, key) in user.report_conversation_reasons"
                    :key="`report-conversation-reason-${key}`"
                >
                    <label>
                        <input
                            type="radio"
                            name="report_reason"
                            ref="reason"
                            :value="key"
                            v-model="formData.report_reason"
                            v-validate.persist="'required'"
                            data-vv-as="report reason"
                            @change="onChangeReason"
                        >
                        {{ reason }}
                    </label>
                </div>
                <div class="form-error">{{ errors.first('report_reason') }}</div>
            </div>
            <div class="form-group" v-if="showReasonDescription">
                <textarea
                    name="report_reason_description"
                    class="form-control"
                    :class="{'has-error': errors.first('report_reason_description') }"
                    v-model="formData.report_reason_description"
                    v-validate.persist="`max:150|required_if:reason,${user.report_conversation_reasons.length - 1}`"
                    data-vv-as="reason"
                ></textarea>
                <div class="form-error">{{ errors.first('report_reason_description') }}</div>
            </div>
        </template>
        <template v-slot:footer>
            <div class="row">
                <div class="col-6 text-right">
                    <button
                        type="button"
                        class="btn btn--transparent-outlined"
                        :disabled="isLoading"
                        @click.prevent="onReport"
                    >
                        Report
                    </button>
                </div>
                <div class="col-6">
                    <button
                        type="button"
                        class="btn btn--secondary"
                        :disabled="isLoading"
                        @click.prevent="onCancel"
                    >
                        Cancel
                    </button>
                </div>
            </div>
        </template>
    </SimpleModal>
</template>

<script>
import { mapState } from 'vuex';
import SimpleModal from '@components/partials/modal/SimpleModal.vue';

export default {
    $_veeValidate: {
        validator: 'new', // give me my own validator scope.
    },
    components: {
        SimpleModal,
    },
    props: {
        showModal: {
            type: Boolean,
            required: true,
        },
        conversation: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            formData: {
                conversation_sid: this.conversation.sid,
                report_reason: '',
                report_reason_description: '',
            },
            showReasonDescription: false,
            isLoading: false,
        };
    },
    updated() {
        if (this.showModal) {
            this.formData = {
                conversation_sid: this.conversation.sid,
                report_reason: '',
                report_reason_description: '',
            };
            this.showReasonDescription = false;
        }
        this.$validator.reset();
    },
    computed: {
        ...mapState('user', ['user']),
    },
    methods: {
        onReport() {
            this.$validator.validate().then((valid) => {
                if (valid) {
                    this.isLoading = true;
                    this.axios.post(`/api/chat/conversations/${this.conversation.sid}/report`, this.formData)
                        .then(({ data }) => {
                            window.showToastSuccess('Successfully reported.');
                            this.$emit('reported');
                            this.$emit('close');
                        })
                        .finally(() => {
                            this.isLoading = false;
                        });
                }
            });
        },
        onCancel() {
            this.$emit('close');
        },
        onChangeReason(event) {
            this.showReasonDescription = parseFloat(event.target.value) === this.user.report_conversation_reasons.length - 1;
            if (!this.showReasonDescription) {
                this.formData.report_reason_description = '';
            }
        },
    },
};
</script>
